<template>
  <div id="attendance-title">
    <span v-html="$t('mypage.attendance.title')"></span>
    <button :id="`${sideBar}attendance-img`" class="d-flex align-items-center ml-1">
      <img class="attendance" :src="`${$s3}/img/common/lotto/question.svg?${$ver}`" />
    </button>
    <b-tooltip :target="`${sideBar}attendance-img`" no-fade triggers="hover" custom-class="tooltip-middle">
      <!-- placement="topright" -->
      <div id="attendance-tooltip">
        <div style="text-align: center" v-html="$t('mypage.attendance.count', { cnt_attendance: cntAttendance })"></div>
        <div class="attendance_info paragraph">
          <p>{{ $t('mypage.attendance.content') }}</p>
          <p>{{ $t('mypage.attendance.content1') }}</p>
          <p>{{ $t('mypage.attendance.content2') }}</p>
          <p>{{ $t('mypage.attendance.content3') }}</p>
        </div>
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    cntAttendance: {
      type: Number,
      default: 0,
    },
    sideBar: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
#attendance-title {
  font-size: 14px;
  font-weight: 500;
  color: #001c41;
  display: flex;
  align-items: center;

  .attendance {
    width: 14px;
  }
}

#attendance-tooltip {
  padding: 2px;

  .attendance_info {
    text-align: left !important;
    margin-top: 4px;

    &.paragraph {
      p {
        margin: 0;
        margin-left: 12.2px;

        &:not(.no-indent) {
          text-indent: -11.2px;
        }
      }
    }
  }
}
</style>
